import * as React from "react";

const SvgIcon = (props) => (
  <svg
    id="svg322"
    width={112}
    height={112}
    viewBox="0 0 112 112"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs id="defs326" />
    <g id="g328">
      <rect
        style={{
          fill: "#f9b900",
          fillOpacity: 1,
          stroke: "none",
          strokeWidth: 5.36506,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          paintOrder: "markers stroke fill",
        }}
        id="rect3270"
        width={112}
        height={112}
        x={0}
        y={0}
      />
      <g
        aria-label="LES QUATRE BARRES"
        id="text440"
        style={{
          fontSize: "21.0112px",
          lineHeight: 0.8,
          fontFamily: "'Noto Sans'",
          InkscapeFontSpecification: "'Noto Sans'",
          textAlign: "center",
          textAnchor: "middle",
          fill: "#8b0934",
          stroke: "#382c30",
          strokeWidth: 1.72357,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          paintOrder: "markers stroke fill",
        }}
      >
        <path
          d="m 15.155535,46.290203 v -14.70784 h 2.26921 v 12.522675 h 6.891673 v 2.185165 z"
          style={{
            fontFamily: "Lexend",
            InkscapeFontSpecification: "Lexend",
            textAlign: "start",
            letterSpacing: "-0.25px",
            textAnchor: "start",
            stroke: "none",
          }}
          id="path293"
        />
        <path
          d="m 27.491264,46.290203 v -14.70784 h 9.265939 v 2.185165 h -6.99673 v 10.33751 h 6.99673 v 2.185165 z m 1.029548,-6.450438 V 37.6546 h 7.080775 v 2.185165 z"
          style={{
            fontFamily: "Lexend",
            InkscapeFontSpecification: "Lexend",
            textAlign: "start",
            letterSpacing: "-0.25px",
            textAnchor: "start",
            stroke: "none",
          }}
          id="path295"
        />
        <path
          d="m 44.680567,46.500315 q -1.197639,0 -2.227188,-0.315168 -1.008537,-0.315168 -1.848985,-0.945504 -0.819437,-0.651347 -1.470784,-1.596851 l 1.554829,-1.785952 q 1.029548,1.470784 1.975052,2.038086 0.945504,0.567303 2.248199,0.567303 0.798425,0 1.449773,-0.252135 0.651347,-0.252134 1.029548,-0.693369 0.378202,-0.441235 0.378202,-1.008538 0,-0.378201 -0.126067,-0.714381 Q 47.517079,41.457627 47.243933,41.184482 46.991799,40.911336 46.571575,40.680213 46.172362,40.44909 45.626071,40.281 45.079779,40.091899 44.365399,39.965832 43.230794,39.734709 42.390346,39.356507 41.549898,38.978306 40.982595,38.411003 40.415293,37.843701 40.142147,37.12932 q -0.273145,-0.735392 -0.273145,-1.638874 0,-0.88247 0.378201,-1.638873 0.399213,-0.756403 1.071572,-1.302695 0.693369,-0.567302 1.617862,-0.861459 0.924493,-0.315168 1.996064,-0.315168 1.134605,0 2.080109,0.294157 0.945504,0.294157 1.680896,0.88247 0.735392,0.567303 1.218649,1.407751 l -1.596851,1.57584 Q 47.89528,34.839099 47.37,34.376853 q -0.52528,-0.483258 -1.155616,-0.714381 -0.630336,-0.252134 -1.344717,-0.252134 -0.819436,0 -1.428761,0.252134 -0.609325,0.252134 -0.966515,0.714381 -0.33618,0.441235 -0.33618,1.05056 0,0.441235 0.16809,0.819437 0.16809,0.35719 0.504269,0.651347 0.35719,0.273145 0.945504,0.504269 0.588313,0.210112 1.40775,0.378201 1.155616,0.252135 2.059098,0.651347 0.903481,0.378202 1.533817,0.903482 0.630336,0.52528 0.945504,1.176627 0.33618,0.651347 0.33618,1.407751 0,1.40775 -0.651348,2.437299 -0.651347,1.029548 -1.848985,1.596851 -1.197639,0.546291 -2.857523,0.546291 z"
          style={{
            fontFamily: "Lexend",
            InkscapeFontSpecification: "Lexend",
            textAlign: "start",
            letterSpacing: "-0.25px",
            textAnchor: "start",
            stroke: "none",
          }}
          id="path297"
        />
        <path
          d="m 25.997314,65.728186 -5.588979,-7.395943 2.122131,-1.449772 5.525946,7.332908 z m -4.580441,-2.10112 q -1.57584,0 -2.920557,-0.567303 -1.344717,-0.567302 -2.353255,-1.57584 -0.987526,-1.029548 -1.533817,-2.416288 -0.546291,-1.386739 -0.546291,-3.025612 0,-1.638874 0.546291,-3.025613 0.546291,-1.386739 1.533817,-2.395277 1.008538,-1.029549 2.353255,-1.596851 1.344717,-0.567303 2.920557,-0.567303 1.596851,0 2.941568,0.567303 1.344716,0.567302 2.332243,1.596851 0.987526,1.029549 1.533817,2.416288 0.546292,1.365728 0.546292,3.004602 0,1.617862 -0.546292,3.004601 -0.546291,1.386739 -1.533817,2.416288 -0.987527,1.029549 -2.332243,1.596851 -1.344717,0.567303 -2.941568,0.567303 z m 0,-2.605389 q 1.008537,0 1.827974,-0.35719 0.840448,-0.378202 1.449773,-1.05056 0.609325,-0.69337 0.945504,-1.596852 0.35719,-0.903481 0.35719,-1.975052 0,-1.071572 -0.35719,-1.975053 -0.336179,-0.903482 -0.945504,-1.57584 -0.609325,-0.69337 -1.449773,-1.05056 -0.819437,-0.378202 -1.827974,-0.378202 -0.987527,0 -1.827975,0.378202 -0.840448,0.35719 -1.449773,1.029549 -0.609324,0.672358 -0.945504,1.57584 -0.336179,0.903481 -0.336179,1.996064 0,1.071571 0.336179,1.996064 0.33618,0.903481 0.945504,1.57584 0.609325,0.672358 1.449773,1.05056 0.840448,0.35719 1.827975,0.35719 z"
          style={{
            fontWeight: 500,
            fontFamily: "Lexend",
            InkscapeFontSpecification: "'Lexend Medium'",
            textAlign: "start",
            letterSpacing: "0.06px",
            textAnchor: "start",
            stroke: "none",
          }}
          id="path299"
        />
        <path
          d="m 37.676491,63.543021 q -1.74393,0 -3.109658,-0.735392 -1.365728,-0.756403 -2.164153,-2.059098 -0.777415,-1.323705 -0.777415,-2.98359 v -9.076838 h 2.752468 v 8.887737 q 0,0.987527 0.441235,1.764941 0.462246,0.756403 1.218649,1.21865 0.756404,0.462246 1.638874,0.462246 0.966515,0 1.74393,-0.462246 0.777414,-0.462247 1.218649,-1.21865 0.462247,-0.777414 0.462247,-1.764941 v -8.887737 h 2.647411 v 9.076838 q 0,1.659885 -0.798426,2.98359 -0.777414,1.302695 -2.143142,2.059098 -1.365728,0.735392 -3.130669,0.735392 z"
          style={{
            fontWeight: 500,
            fontFamily: "Lexend",
            InkscapeFontSpecification: "'Lexend Medium'",
            textAlign: "start",
            letterSpacing: "0.06px",
            textAnchor: "start",
            stroke: "none",
          }}
          id="path301"
        />
        <path
          d="m 45.53165,63.416954 5.736058,-14.70784 h 2.563366 l 5.694035,14.70784 h -2.836512 l -3.15168,-8.362458 Q 53.431861,54.802362 53.24276,54.256071 53.074671,53.709779 52.864559,53.079443 52.654447,52.428096 52.486357,51.881805 52.318268,51.314503 52.234223,51.062368 l 0.52528,-0.02101 q -0.126067,0.420224 -0.294157,0.945504 -0.16809,0.52528 -0.35719,1.092582 -0.189101,0.567303 -0.378202,1.092583 -0.16809,0.52528 -0.315168,0.945504 l -3.15168,8.299424 z m 2.605389,-3.361792 0.945504,-2.374266 h 6.702573 l 1.008537,2.374266 z"
          style={{
            fontWeight: 500,
            fontFamily: "Lexend",
            InkscapeFontSpecification: "'Lexend Medium'",
            textAlign: "start",
            letterSpacing: "0.06px",
            textAnchor: "start",
            stroke: "none",
          }}
          id="path303"
        />
        <path
          d="M 63.787362,63.416954 V 51.230458 h -4.20224 v -2.521344 h 11.262003 v 2.521344 h -4.328307 v 12.186496 z"
          style={{
            fontWeight: 500,
            fontFamily: "Lexend",
            InkscapeFontSpecification: "'Lexend Medium'",
            textAlign: "start",
            letterSpacing: "0.06px",
            textAnchor: "start",
            stroke: "none",
          }}
          id="path305"
        />
        <path
          d="m 73.59656,63.416954 v -14.70784 h 6.387405 q 1.323706,0 2.416288,0.630336 1.092583,0.609325 1.722919,1.680896 0.651347,1.05056 0.651347,2.374265 0,1.260672 -0.651347,2.332244 -0.630336,1.05056 -1.722919,1.680896 -1.071571,0.609324 -2.416288,0.609324 h -3.718982 v 5.399879 z m 8.530548,0 -3.739994,-6.639539 2.815501,-0.52528 4.160217,7.18583 z M 76.264983,55.64281 h 3.739993 q 0.609325,0 1.05056,-0.273146 0.462247,-0.294157 0.714381,-0.798425 0.252135,-0.504269 0.252135,-1.113594 0,-0.69337 -0.315168,-1.197638 -0.315168,-0.504269 -0.882471,-0.798426 -0.567302,-0.294157 -1.302694,-0.294157 h -3.256736 z"
          style={{
            fontWeight: 500,
            fontFamily: "Lexend",
            InkscapeFontSpecification: "'Lexend Medium'",
            textAlign: "start",
            letterSpacing: "0.06px",
            textAnchor: "start",
            stroke: "none",
          }}
          id="path307"
        />
        <path
          d="m 88.301379,63.416954 v -14.70784 h 9.62313 v 2.479321 h -6.933696 v 9.749197 h 7.017741 v 2.479322 z m 1.260672,-6.30336 v -2.437299 h 7.290887 v 2.437299 z"
          style={{
            fontWeight: 500,
            fontFamily: "Lexend",
            InkscapeFontSpecification: "'Lexend Medium'",
            textAlign: "start",
            letterSpacing: "0.06px",
            textAnchor: "start",
            stroke: "none",
          }}
          id="path309"
        />
        <path
          d="m 14.945423,80.543705 v -14.70784 h 6.492461 q 1.512806,0 2.563366,0.441235 1.05056,0.420224 1.57584,1.239661 0.546291,0.798425 0.546291,1.93303 0,1.260672 -0.630336,2.122131 -0.609324,0.861459 -1.785952,1.155616 l -0.04202,-0.399213 q 0.987526,0.210112 1.701907,0.735392 0.735392,0.52528 1.134605,1.302695 0.399213,0.756403 0.399213,1.722918 0,1.113594 -0.378202,1.954042 -0.378201,0.819437 -1.092582,1.386739 -0.714381,0.567302 -1.680896,0.840448 -0.945504,0.273146 -2.10112,0.273146 z m 3.361792,-2.983591 h 3.214714 q 0.588313,0 0.987526,-0.189101 0.420224,-0.1891 0.651347,-0.546291 0.231123,-0.378201 0.231123,-0.903481 0,-0.483258 -0.252134,-0.819437 -0.231123,-0.336179 -0.672358,-0.504269 -0.441236,-0.189101 -1.05056,-0.189101 h -3.109658 z m 0,-5.820102 h 2.6264 q 0.546291,0 0.924493,-0.16809 0.399213,-0.189101 0.588313,-0.504269 0.210112,-0.336179 0.210112,-0.798425 0,-0.672359 -0.462246,-1.05056 -0.462246,-0.399213 -1.386739,-0.399213 h -2.500333 z"
          style={{
            fontWeight: "bold",
            fontFamily: "Lexend",
            InkscapeFontSpecification: "'Lexend Bold'",
            textAlign: "start",
            textAnchor: "start",
            stroke: "none",
          }}
          id="path311"
        />
        <path
          d="m 27.804282,80.543705 5.820103,-14.70784 h 3.025613 l 5.77808,14.70784 h -3.613927 l -2.773478,-7.458976 q -0.16809,-0.441236 -0.336179,-0.945504 -0.16809,-0.504269 -0.33618,-1.029549 -0.168089,-0.546291 -0.336179,-1.05056 -0.147078,-0.52528 -0.252134,-0.966515 l 0.630336,-0.02101 q -0.126067,0.52528 -0.294157,1.029549 -0.147078,0.504269 -0.315168,1.008538 -0.147078,0.483257 -0.336179,0.987526 -0.189101,0.483258 -0.357191,1.008538 l -2.773478,7.437965 z m 2.773479,-2.815501 1.113593,-2.689434 h 6.765607 l 1.092582,2.689434 z"
          style={{
            fontWeight: "bold",
            fontFamily: "Lexend",
            InkscapeFontSpecification: "'Lexend Bold'",
            textAlign: "start",
            textAnchor: "start",
            stroke: "none",
          }}
          id="path313"
        />
        <path
          d="m 44.256058,80.543705 v -14.70784 h 6.618528 q 1.40775,0 2.542355,0.609324 1.155616,0.609325 1.806963,1.680896 0.651347,1.05056 0.651347,2.395277 0,1.386739 -0.651347,2.500333 -0.651347,1.092582 -1.785952,1.722918 -1.134605,0.630336 -2.563366,0.630336 h -3.214714 v 5.168756 z m 8.152345,0 -3.739993,-6.63954 3.655948,-0.52528 4.160218,7.16482 z m -4.748531,-7.900212 h 2.899546 q 0.546291,0 0.945504,-0.231123 0.420224,-0.252134 0.630336,-0.693369 0.231123,-0.441236 0.231123,-1.008538 0,-0.567302 -0.252135,-0.987526 -0.252134,-0.441236 -0.735392,-0.672359 -0.462246,-0.231123 -1.134604,-0.231123 h -2.584378 z"
          style={{
            fontWeight: "bold",
            fontFamily: "Lexend",
            InkscapeFontSpecification: "'Lexend Bold'",
            textAlign: "start",
            textAnchor: "start",
            stroke: "none",
          }}
          id="path315"
        />
        <path
          d="m 59.005913,80.543705 v -14.70784 h 6.618528 q 1.40775,0 2.542355,0.609324 1.155616,0.609325 1.806963,1.680896 0.651347,1.05056 0.651347,2.395277 0,1.386739 -0.651347,2.500333 -0.651347,1.092582 -1.785952,1.722918 -1.134605,0.630336 -2.563366,0.630336 h -3.214714 v 5.168756 z m 8.152345,0 -3.739993,-6.63954 3.655948,-0.52528 4.160218,7.16482 z m -4.748531,-7.900212 h 2.899546 q 0.546291,0 0.945504,-0.231123 0.420224,-0.252134 0.630336,-0.693369 0.231123,-0.441236 0.231123,-1.008538 0,-0.567302 -0.252135,-0.987526 -0.252134,-0.441236 -0.735392,-0.672359 -0.462246,-0.231123 -1.134604,-0.231123 h -2.584378 z"
          style={{
            fontWeight: "bold",
            fontFamily: "Lexend",
            InkscapeFontSpecification: "'Lexend Bold'",
            textAlign: "start",
            textAnchor: "start",
            stroke: "none",
          }}
          id="path317"
        />
        <path
          d="m 73.755768,80.543705 v -14.70784 h 10.253465 v 3.046624 h -6.786617 v 8.614592 h 6.996729 v 3.046624 z m 1.680896,-6.030215 v -2.899545 h 7.627065 v 2.899545 z"
          style={{
            fontWeight: "bold",
            fontFamily: "Lexend",
            InkscapeFontSpecification: "'Lexend Bold'",
            textAlign: "start",
            textAnchor: "start",
            stroke: "none",
          }}
          id="path319"
        />
        <path
          d="m 92.182601,80.753817 q -1.449773,0 -2.6264,-0.33618 -1.155616,-0.35719 -2.059098,-1.008537 -0.903481,-0.672359 -1.617862,-1.57584 l 2.164153,-2.458311 q 1.05056,1.407751 2.10112,1.891008 1.071572,0.483258 2.206176,0.483258 0.567303,0 1.029549,-0.147078 0.462247,-0.147079 0.714381,-0.420224 0.252134,-0.294157 0.252134,-0.714381 0,-0.315168 -0.168089,-0.567303 -0.147079,-0.252134 -0.420224,-0.441235 -0.273146,-0.189101 -0.651347,-0.336179 -0.378202,-0.16809 -0.798426,-0.273146 -0.420224,-0.126067 -0.861459,-0.210112 -1.21865,-0.273145 -2.122131,-0.672358 -0.903482,-0.399213 -1.512807,-0.966515 -0.588313,-0.588314 -0.88247,-1.323706 -0.294157,-0.756403 -0.294157,-1.680896 0,-0.987526 0.441235,-1.806963 0.462247,-0.840448 1.21865,-1.428762 0.777414,-0.609324 1.785952,-0.924492 1.008537,-0.33618 2.10112,-0.33618 1.449773,0 2.479321,0.315168 1.05056,0.294157 1.785952,0.86146 0.756404,0.567302 1.281684,1.365728 l -2.206176,2.122131 q -0.441236,-0.546291 -0.966516,-0.903482 -0.504268,-0.35719 -1.092582,-0.546291 -0.567302,-0.189101 -1.176627,-0.189101 -0.630336,0 -1.092583,0.16809 -0.441235,0.147078 -0.693369,0.441235 -0.252135,0.273146 -0.252135,0.672358 0,0.357191 0.210112,0.609325 0.210112,0.252135 0.567303,0.462247 0.35719,0.1891 0.819437,0.336179 0.462246,0.126067 0.966515,0.210112 1.155616,0.231123 2.080109,0.609325 0.945504,0.378201 1.617862,0.924492 0.69337,0.546292 1.05056,1.302695 0.378202,0.735392 0.378202,1.722918 0,1.533818 -0.756404,2.605389 -0.735392,1.05056 -2.038086,1.617862 -1.281683,0.546292 -2.962579,0.546292 z"
          style={{
            fontWeight: "bold",
            fontFamily: "Lexend",
            InkscapeFontSpecification: "'Lexend Bold'",
            textAlign: "start",
            textAnchor: "start",
            stroke: "none",
          }}
          id="path321"
        />
      </g>
      <path
        id="rect3488"
        style={{
          fill: "#8b0934",
          fillOpacity: 1,
          stroke: "none",
          strokeWidth: 1.77712,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          paintOrder: "markers stroke fill",
        }}
        d="M 14,0 V 27.246094 H 26 V 0 Z M 38,0 V 27.246094 H 50 V 0 Z M 62,0 V 44.585938 H 74 V 0 Z M 86,0 V 44.585938 H 98 V 0 Z M 14,84.753906 V 112 H 26 V 84.753906 Z m 24,0 V 112 H 50 V 84.753906 Z m 24,0 V 112 H 74 V 84.753906 Z m 24,0 V 112 H 98 V 84.753906 Z"
      />
    </g>
  </svg>
);

export default SvgIcon;
